export class Fuel {
    id: number;
    name: string;
}
